import axiosClient from "@/shared/lib/axios/axios";
import { ApiResponse } from "@/shared/types/api";

export interface OrganizationMember {
  id: number;
  username: string;
  email: string;
  full_name: string;
}

export const getOrganizationMembers = async (
  orgId: number
): Promise<OrganizationMember[]> => {
  const res = await axiosClient.get<ApiResponse<OrganizationMember[]>>(
    `/users/organizations/${orgId}/members/`
  );
  return res?.data?.data ?? [];
};
